import './Detail.component.css'

import { Col, Grid, Row } from 'react-bootstrap'

import PropTypes from 'prop-types'
import React from 'react'
import SampleContainerComponent from '../SampleContainer/SampleContainer.component'
import { Stage } from 'react-konva'
import { axios } from 'config/axios'
import { connect } from 'react-redux'
import { getUpdateSampleChangerLocationURL } from '../../../api/ispyb'

export class DetailComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hoveredSampleName: null,
      hoveredProteinAcronyme: null,
      hoveredPosition: null,
      hoveredStatus: null,
    }

    this.onMouseOverSample = this.onMouseOverSample.bind(this)
  }

  unloadSelected() {
    if (this.props.selectedShipment) {
      axios({
        url: getUpdateSampleChangerLocationURL(
          this.props.user,
          this.props.proposalName,
          this.props.selectedShipment.containerId,
          this.props.selectedShipment.beamlineLocation
        ),
        method: 'POST',
        mode: 'no-cors',
        data: 'sampleChangerLocation=',
      }).then(() => {
        this.props.fetchDataCallback()
      })
    }
  }

  onMouseOverSample = (hoveredSampleName, hoveredProteinAcronyme, hoveredPosition, hoveredStatus) => {
    this.setState({
      hoveredSampleName: hoveredSampleName,
      hoveredProteinAcronyme: hoveredProteinAcronyme,
      hoveredPosition: hoveredPosition,
      hoveredStatus: hoveredStatus,
    })
  }

  renderSpy() {
    const res = []

    res.push(
      <Row>
        <Col xs={3}>BLSample_name</Col>
        <Col xs={3}>Protein_acronym</Col>
        <Col xs={3}>BLSample_location</Col>
        <Col xs={3}>status</Col>
      </Row>
    )

    res.push(
      <Row>
        <Col xs={3}>{this.state.hoveredSampleName}</Col>
        <Col xs={3}>{this.state.hoveredProteinAcronyme}</Col>
        <Col xs={3}>{this.state.hoveredPosition}</Col>
        <Col xs={3}>{this.state.hoveredStatus}</Col>
      </Row>
    )

    return res
  }

  renderList() {
    const res = []

    res.push(
      <Row>
        <Col xs={3}>BLSample_name</Col>
        <Col xs={3}>Protein_acronym</Col>
        <Col xs={3}>BLSample_location</Col>
        <Col xs={3}>status</Col>
      </Row>
    )

    this.props.samplesOfSelectedSampleContainer.forEach(sample => {
      res.push(
        <Row>
          <Col xs={3}>{sample.sampleName}</Col>
          <Col xs={3}>{sample.proteinAcronyme}</Col>
          <Col xs={3}>{sample.position}</Col>
          <Col xs={3}>{sample.status}</Col>
        </Row>
      )
    })

    return res
  }

  shouldComponentUpdate() {
    return true
  }

  componentDidMount() {
    this.setState({})
  }

  render() {
    const style = {
      'margin-top': '20px',
      'border-color': 'this.props.selectedSampleContainer &&',
      'border-width': '2px',
      'border-style': 'solid',
      width: '100%',
      height: '300px',
      'overflow-y': 'scroll',
    }

    return (
      <div style={style}>
        {this.props.selectedSampleContainer && this.props.samplesOfSelectedSampleContainer && (
          <Grid fluid>
            <Row>
              <Col lg={10}>
                <Grid fluid>
                  {/*{ this.renderList()}*/}

                  <Stage width={215} height={215} visible opacity={1}>
                    <SampleContainerComponent
                      onMouseOverSample={this.onMouseOverSample}
                      updateSelectedSampleContainerCallback={() => {}}
                      updateSamplesOfSelectedSampleContainerCallback={() => {}}
                      fetchDataCallback={() => {}}
                      user={this.props.user}
                      username={this.props.user.username}
                      proposalName={this.props.proposalName}
                      position_in_container={0}
                      showSamples
                      selectedShipment={this.props.selectedShipment}
                      status="FILLED"
                      samples={this.props.samplesOfSelectedSampleContainer}
                      selectedSampleContainer={this.props.selectedShipment}
                      configuration={this.props.configuration}
                      sample_container_radius={107}
                      sample_container_position_from_top={107}
                      sample_container_position_from_left={107}
                    />
                  </Stage>

                  {this.renderSpy()}
                </Grid>
              </Col>

              <Col lg={2}>
                <button
                  type="button"
                  onClick={() => {
                    this.unloadSelected()
                  }}
                >
                  Unload Selected
                </button>
              </Col>
            </Row>
          </Grid>
        )}
      </div>
    )
  }
}

export default connect()(DetailComponent)

DetailComponent.propTypes = {
  sample_container_radius: PropTypes.number,
  sample_container_position_from_top: PropTypes.number,
  sample_container_position_from_left: PropTypes.number,
  sample_container_background_color: PropTypes.string,
  sample_container_border_color: PropTypes.string,
}
